import { InjectionToken } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DialogsService } from "./dialogs.service";
export { DialogsService, NgbActiveModal, NgbModal, type NgbModalOptions };

export const DIALOG_DATA = new InjectionToken<DialogOptions>('DIALOG_DATA');

export interface DialogOptions {
    message: string;
    title?: string;
  }

  export class Dialogs {
    static Dialogs:DialogsService;
    static alert = (...$_: Parameters<DialogsService['alert']>) => this.Dialogs.alert(...$_);
    static confirm = (...$_: Parameters<DialogsService['confirm']>) => this.Dialogs.confirm(...$_);
  }
